import React from "react";
import ReactDOM from "react-dom";
import WishListRoutes from "./routes/wishlist";
import "./styles/sass/_reset.scss";

ReactDOM.render(
    <>
        <WishListRoutes />
    </>,
    document.getElementById("root")
);
